const initialState = {
    pending: false,
    drainStations: [],
    page: 0,
    itemsCount: 0,
    pageCount: 0,
    error: null,
    filters: {active: 'ALL', itemsPerPage: 3, search: ''},
    selected: {}
};

const drainStationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_DRAIN_STATIONS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_DRAIN_STATIONS_SUCCESS':
            return {
                ...state,
                pending: false,
                drainStations: action.stations,
                page: action.page,
                pageCount: action.pageCount,
                itemsCount: action.itemsCount
            };
        case 'GET_DRAIN_STATIONS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'SELECT_DRAIN_STATION':
            return {
                ...state,
                selected: action.selected
            };
        case 'SET_DRAIN_STATIONS_FILTERS':
            return {
                ...state,
                filters: action.filters
            };
        case 'ADD_GATE_SWITCHER_SUCCESS':
            return {
                ...state,
                pending: false
            };
        case 'ADD_DRAIN_STATION_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        default:
            return state;
    }
};

export default drainStationsReducer;
